export default "__VITE_ASSET__CVbd4Ja0__"